import React, { Component } from 'react';
import MdCheckmarkCircleOutline from 'react-ionicons/lib/MdCheckmarkCircleOutline';

class OrderInfo extends Component {
    render() {
        return (
            <div className="row mb-4 ml-1 mr-1 mt-4">
                <div className="col-12">
                    {
                        this.props.isMedical != true && (
                    <div>        
                    <span className="d-block mt-2"><MdCheckmarkCircleOutline />
                    To confirm your booking, an advance payment along with the applicable refundable security deposit is required.                    </span>
                    <span className="d-block mt-2"><MdCheckmarkCircleOutline />
                    After payment, please upload your Aadhaar Card, PAN Card, Rent Agreement/Address Proof, and Job Proof (Employee ID, Offer Letter, Salary Slip) or a recent Bank Statement for KYC verification. Based on the verification, our team will inform you whether your order is approved for Monthly Rental or Upfront / No-Cost EMI.                    </span>
                    </div>)
                    }
                    <span className="d-block mt-2"><MdCheckmarkCircleOutline />
                    Your billing cycle will start from the delivery date of your rented items.
                    </span>
                    <span className="d-block mt-2"><MdCheckmarkCircleOutline />
                    Please note: The minimum rental amount is ₹1,000 for orders in Delhi and Manesar, ₹500 for orders in Gurugram, and ₹1,500 for orders in Noida and Ghaziabad.
                    </span>
                    <span className="d-block mt-2"><MdCheckmarkCircleOutline />
                    If you choose to terminate or return your rented product before the completion of the lock-in period, applicable transportation/pickup charges will be payable in addition to any other charges as per the rental agreement.
                    </span>
                    <span className="d-block mt-2"><MdCheckmarkCircleOutline />
                    No-Cost EMI is applicable only on eligible Credit Cards for the selected tenure, with no additional charges.
                    </span>
                    
                    {
                        this.props.isMedical==true && (
                            <div>
                                <span className="d-block mt-2"><MdCheckmarkCircleOutline />
                                    Rates are without gst ( 18% gst will be applied).	
                                </span>
                                <span className="d-block mt-2"><MdCheckmarkCircleOutline />
                                    Delivery charges will be according to the distance.
                                </span>
                                <span className="d-block mt-2"><MdCheckmarkCircleOutline />
                                    Post delivery check will be collected at the time of delivery equivalent to cost of equipment.
                                </span>
                            </div>
                        )
                    }
                </div>
            </div>
        );
    }
}

export default OrderInfo;